import React, { PureComponent } from 'react';
import { ambient } from '@aw_products/ambient-weather-common'
import bindAllActions from '../../common/bindAllActions'
import PropTypes from 'prop-types';
import AlertForm from './AlertForm'
import { path, not, clone, map, propEq, equals, pipe, find, nth, indexOf, contains, test } from 'ramda'
import { hasHst, shouldGetDevice, getTheDevice, isRole, isSomething, isLoggedIn, convertUnitInverse, getMasterUnitParam, getLabelForDevice, getDeviceLabel, getDisplayKeys, objsContainId, ALERT_CONDITIONS, getConditionLabel, pathsChanged } from '../../common/ambient'
import classNames from 'classnames'
import DeviceChooser from '../../components/DeviceChooser'
import AlertList from './AlertList'
import HsThreshold from '../device/HsThreshold';

const conditions = ALERT_CONDITIONS

class Crud extends PureComponent {
  static propTypes = {
    alertActions: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired,
    alert: PropTypes.object.isRequired,
    user: PropTypes.object,
  };

  state = {
    param: '',
    condition: '',
    dirtyThreshold: '',
    threshold: '',
    unit: '',
  };

  isButtonDisabled = () => {
    const { param, condition, threshold } = this.state;
    return !(
      param &&
      contains(condition, conditions.map(arr => arr[1])) &&
      (param === 'notReporting' || isSomething(threshold))
    );
  }

  componentDidMount() {
    const { deviceActions } = this.props
    deviceActions.ensureDashboardDevice()
  }

  componentDidUpdate(prevState) {
    const { device, deviceActions, user, alert, alertActions } = this.props
    const theDevice = this._theDevice()

    // Ensure dashboardDevice is set when data becomes available
    deviceActions.ensureDashboardDevice()

    if (isLoggedIn(user) && !alert.alerts) {
      alertActions.fetchAlerts({
        userId: user.info._id
      })
    }

    if (pathsChanged(prevState, this.state, ['param']) && this._isWgbtGuideline()) {
      this.setState({
        zone: this._hstGuildeine().zones[0].label
      })
    }
  }

  reset = () => {
    this.setState({
      param: '',
      condition: '',
      dirtyThreshold: '',
      threshold: '',
      unit: ''
    })
  }

  createAlert = (alrt) => {
    const { alertActions } = this.props
    alrt.deviceId = this._theDevice()._id
    
    // Make sure we preserve the data property (which includes zone and guideline for WBGT alerts)
    
    alertActions.createAlert(alrt)
    this.reset()
  }

  _theDevice = () => {
    const { device } = this.props
    return getTheDevice(device)
  }
  _hstGuildeine() {
    const theDevice = this._theDevice()
    if (hasHst(theDevice) && path(['settings', 'hst', 'guideline'], theDevice)) {
      return ambient.HST.getFinalGuildeline(theDevice.settings.hst)
    }
  }
  _isWgbtGuideline() {
    return this.state.param === ambient.HST.ALERT_ID
  }

  handleInputChange = (values) => {
    this.setState(values);
  }

  render() {
    const { dirtyThreshold, threshold, unit, units, param, condition, deviceId, zone } = this.state
    const { user, alertActions, device } = this.props
    const { devices } = device
    let deviceSelect = ''
    if (this._theDevice()) {
      deviceSelect = <div className="device-chooser">
          <DeviceChooser  />
        </div>
    }
    let unitSelect = ''
    if (units) {
      unitSelect =
        <select
          className="form-control"
          onChange={evt => this.setState({ unit: evt.target.value })}
          value={unit}
        >
          {units.map(unt => <option key={unt} value={unt}>{unt}</option>)}
        </select>
    }
    let buttonDisabled = !(param && contains(condition, map(nth(1), conditions)) && isSomething(threshold))
    if (param === 'notReporting' || this._isWgbtGuideline()) {
      buttonDisabled = false
    }
    let paramSelect = ''
    const theDevice = this._theDevice()
    
    if (theDevice) {
      const theKeys = getDisplayKeys([theDevice.lastData])
        .filter(k => k !== 'dateutc')
        .filter(pipe(test(/^leak\d$/), not)) // leak alerts are auto-created
      theKeys.push('notReporting')
      let wbgtGuildelines = null 
      const finalGuideline = this._hstGuildeine() 
      if (finalGuideline) {
        wbgtGuildelines = <option value={ambient.HST.ALERT_ID}>WBGT Guidelines - {finalGuideline.name}</option>
      }
      paramSelect = <select
        className="form-control"
        onChange={evt => this.setState({ param: evt.target.value })}
        value={param}
      >
        <option>Parameter</option>
        {wbgtGuildelines}
        {theKeys.map(key => <option key={key} value={key}>{getLabelForDevice(key, theDevice)}</option>)}
      </select>
    }
    let conditionAndAmount = (
      <>
        <select
          className="form-control condition"
          onChange={evt => this.setState({ condition: evt.target.value })}
          value={condition}
        >
          <option>Condition</option>
          {conditions.map((arr, i) => <option key={i} value={arr[1]}>{arr[0]}</option>)}
        </select>
        <div className="input-group amount">
          <input
            type="number"
            placeholder="Amount"
            onChange={evt => this.setState({ dirtyThreshold: evt.target.value })}
            className="boxy"
            value={dirtyThreshold}
          />
          {unitSelect}
        </div>
      </>
    )
    // WBGT guideline functionality moved to AlertForm.js
    return (
      <div className="alert-crud">
        <div className={classNames("create", this.state.param)}>
          {deviceSelect}

          <AlertForm 
            currentDevice={theDevice} 
            onChange={newAlert => {
              this.createAlert(newAlert)
            }} 
          />
        </div>
        <AlertList />
      </div>
    );
  }
}

export default bindAllActions(Crud)
Crud.displayName = 'Crud'